/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiJobState,
    ApiJobStateFromJSON,
    ApiJobStateFromJSONTyped,
    ApiJobStateToJSON,
} from './ApiJobState';

/**
 * 
 * @export
 * @interface ApiJobSetFilter
 */
export interface ApiJobSetFilter {
    /**
     * 
     * @type {Array<ApiJobState>}
     * @memberof ApiJobSetFilter
     */
    states?: Array<ApiJobState>;
}

export function ApiJobSetFilterFromJSON(json: any): ApiJobSetFilter {
    return ApiJobSetFilterFromJSONTyped(json, false);
}

export function ApiJobSetFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiJobSetFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'states': !exists(json, 'states') ? undefined : ((json['states'] as Array<any>).map(ApiJobStateFromJSON)),
    };
}

export function ApiJobSetFilterToJSON(value?: ApiJobSetFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'states': value.states === undefined ? undefined : ((value.states as Array<any>).map(ApiJobStateToJSON)),
    };
}

